export interface IMentionUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  photoProfile: string;
}

export interface IMentionOrderComment {
  id: number;
  orderId: number;
  comment: string;
  imageUrl?: string;
}

export interface IMentionStockOrderComment {
  id: number;
  stockOrderId: number;
  stockOrderUuid: string;
  comment: string;
  imageUrl?: string;
}

export interface IMentionLogisticServiceComment {
  id: number;
  logisticServiceId: number;
  comment: string;
  imageUrl?: string;
}

export interface IuserMention {
  id: number;
  mentioneeUserId: number;
  mentionerUserId: number;
  wasSeen: boolean;
  wasResolved: boolean;
  createdAt: string;
  orderComment?: IMentionOrderComment;
  logisticServiceComment?: IMentionLogisticServiceComment;
  stockOrderComment?: IMentionStockOrderComment;
}

export interface getMentionsByMentioneeUserDto {
  pendingViewingMentions: IuserMention[];
  pendingResolutionMentions: IuserMention[];
  resolvedMentions: IuserMention[];
}

export enum MENTION_STATUS {
  PENDING_VIEWING = 'pending_viewing',
  PENDING_RESOLUTION = 'pending_resolution',
  CLOSED = 'closed'
}

export interface IUpdateMentionDto {
  wasSeen?: boolean;
  wasResolved?: boolean;
}

export interface IBulkUpdateMentionsDto {
  wasSeen: boolean;
  wasResolved: boolean;
  mentionIds: number[];
}

export interface ICommentInfo {
  commentData: IComment | null;
  redirectText: string;
  redirectUrl: string;
}

export const MENTION_TYPES = {
  ORDER: 'order',
  LOGISTIC_SERVICE: 'logisticService',
  STOCK_ORDER: 'stockOrder'
} as const;

export type TMentionTypes = typeof MENTION_TYPES[keyof typeof MENTION_TYPES];

export type IMention = {
  id: number;
  type: TMentionTypes;
  sourceId: number;
  mentioneeUserId: number;
  mentionerUserId: number;
  createdAt: Date;
  wasSeen: boolean;
  wasResolved: boolean;
  comment: IComment;
};

export interface IMentioner {
  id: number;
  name: string;
};

export interface IComment {
  sourceId: number;
  sourceUuid?: string;
  comment: string;
  imageUrl?: string;
};

export interface IGroupedMentionWithMentioner {
  id: number;
  wasSeen: boolean;
  wasResolved: boolean;
  createdAt: string;
  mentioner: IMentioner;
  comment: IComment;
}

export interface IGroupedMention {
  sourceId: number;
  sourceUuid?: string;
  type: TMentionTypes;
  mentions: IGroupedMentionWithMentioner[];
}

export interface IGroupedMentionsResponse {
  pendingViewingMentions: IGroupedMention[];
  pendingResolutionMentions: IGroupedMention[];
  resolvedMentions: IGroupedMention[];
}
